import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

const SContainer = styled('div')(
  ({ theme }) => css`
    direction: ${theme.direction};
    display: flex;
    gap: 1rem;
  `
);

const SPane = styled('div')(
  ({ theme, weight }) => css`
    flex: ${weight};
    text-align: ${theme.direction === 'rtl' ? 'right' : 'left'};
    overflow: hidden;
  `
);

const SplitScreen = ({
  children,
  leftWeight = 1,
  rightWeight = 1,
  className,
}) => {
  const [left, right] = children;

  return (
    <SContainer className={className}>
      <SPane weight={rightWeight} className='right'>
        {right}
      </SPane>
      <SPane weight={leftWeight} className='left'>
        {left}
      </SPane>
    </SContainer>
  );
};

SplitScreen.propTypes = {
  children: PropTypes.node,
  leftWeight: PropTypes.number,
  rightWeight: PropTypes.number,
  className: PropTypes.string,
};

export default SplitScreen;
